import { render } from "./IconUserSlash.vue?vue&type=template&id=2b064886"
import script from "./IconUserSlash.vue?vue&type=script&lang=ts"
export * from "./IconUserSlash.vue?vue&type=script&lang=ts"
script.render = render

export default script